import { all, takeEvery } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { fetchWrapperFuncNoLoading } from '../../../utils';
import { getEventHandlerConfigApi, ServerType } from '../../System/systemConfig';
import { eventHandlerConfigSet, EVENT_HANDLER_CONFIG_LOAD, eventHandlerConfigSetMissing } from './actions';

function* eventHandlerConfigLoad(action: Action<ServerType>) {
    const server = action.payload;
    const api = getEventHandlerConfigApi(server);

    yield* fetchWrapperFuncNoLoading(() => api.getEventHandlerConfiguration(), [
        r => eventHandlerConfigSet({ server, config: r })
    ]);

    yield* fetchWrapperFuncNoLoading(() => api.getEventsWithoutListener(), [
        r => eventHandlerConfigSetMissing({ server, config: r })
    ]);
}

function* watchEventHandlerConfigActions() {
    yield takeEvery(EVENT_HANDLER_CONFIG_LOAD, eventHandlerConfigLoad);
}

export function* eventHandlerConfigSagas() {
    yield all([watchEventHandlerConfigActions()]);
}
